import './berkeleyevents/style';
import FormStructure from './berkeleyevents/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js